import React from 'react'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import QuoteComponent from '../../../Quote/Quote'
import WorkOrderPlaceholder from './WorkOrderPlaceholder'

function WorkOrderBlock(props: PresentationBlockProps) {
  const { WrapperComponent, isSettings, objectLabels } = props

  return (
    <WrapperComponent {...props}>
      {isSettings ? (
        <WorkOrderPlaceholder objectLabels={objectLabels} />
      ) : (
        <QuoteComponent inPresentation={true} view="work-order" />
      )}
    </WrapperComponent>
  )
}

export default React.memo(WorkOrderBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
